// extracted by mini-css-extract-plugin
export default {"movies":"Home_movies__hjXR5","container":"Home_container__kW53a"};